import React from 'react';

const GiftAidTable = ({ list, onDelete }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3 className="card-title mb-4">Gift Aid Declarations</h3>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Charity No.</th>
                <th>Donor Name</th>
                <th>Postcode</th>
                <th>Full Address</th>
                {/* <th>Donation (£)</th> */}
                <th>Declaration Date</th>
                <th>Created On</th>
                <th>Signature</th>
                <th>Actions</th>
                
              </tr>
            </thead>
            <tbody>
              {list.map((data, index) => (
                <tr key={index}>
                  {/* Charity Number (Kept as requested) */}
                  <td>{data.charityNumber}</td> 
                  
                  {/* Donor Name (Assuming data object contains title, firstName, and surname) */}
                  <td>{data.title} {data.firstName} {data.surname}</td> 
                  
                  {/* Postcode (Assuming data object contains postcode) */}
                  <td>{data.postcode}</td>

                  <td>{data.fullAddress}</td>
                  
                  {/* Donation Amount (Assuming data object contains donationAmount) */}
                 {/*  <td>{data.donationAmount ? `£${data.donationAmount}` : 'N/A'}</td> */}
                  
                  {/* Declaration Date (Assuming data object contains declarationDate) */}
                  <td>{data.date}</td>

                  <td>{data.addedTime}</td>

                  <td><img src={data.signature} width={100} height={50}/></td>
                  
                  {/* Delete Button (Action Column) */}
                  <td>
                    <button
                      // Call the onDelete prop, passing the entire data object or a unique ID if available
                      onClick={() => onDelete(data.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GiftAidTable;